import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Spinner,
} from "@dust-tt/sparkle";
// biome-ignore lint/correctness/noUnusedImports: ignored using `--suppress`
import React from "react";
import { useTranslation } from "react-i18next";

interface LeavePodDialogProps {
  isOpen: boolean;
  isLeaving?: boolean;
  isRestricted: boolean;
  onClose: () => void;
  onLeave: () => void;
  podName: string;
}

export const LeavePodDialog = ({
  isLeaving,
  isRestricted,
  onLeave,
  onClose,
  isOpen,
  podName,
}: LeavePodDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("pods.leaveThisPod", "Leave this Pod?")}</DialogTitle>
          <DialogDescription>
            {isRestricted ? (
              <>
                {t(
                  "pods.leaveRestrictedPodDescription",
                  "You will no longer have access to conversations and context in"
                )}{" "}
                <strong>{podName}</strong>.
              </>
            ) : (
              t(
                "pods.leavePodRejoinAnytime",
                "You can rejoin this Pod anytime."
              )
            )}
          </DialogDescription>
        </DialogHeader>
        {isLeaving ? (
          <div className="flex justify-center py-8">
            <Spinner variant="dark" size="md" />
          </div>
        ) : (
          <DialogFooter
            leftButtonProps={{
              label: t("pods.cancel", "Cancel"),
              variant: "outline",
            }}
            rightButtonProps={{
              label: t("pods.leave", "Leave"),
              variant: "warning",
              onClick: onLeave,
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
